<template>
    <div class="nl-app min-h-screen w-full bg-black text-nomad-100">
        <Navigation ref="nav" />
        <Notification />

        <div class="pb-36 lg:pb-28 lg:pl-[16.75rem] lg:pr-2 lg:pt-2">
            <div class="relative min-h-[calc(100vh-1rem)] overflow-clip bg-nomad-850 lg:rounded-xl">
                <TopBar @open-menu="openMenu" />
                <main role="main" class="px-4 pb-12 pt-2 sm:px-6 lg:px-8">
                    <slot></slot>
                </main>
                <Footer class="px-4 sm:px-6 lg:px-8" />
            </div>
        </div>

        <Transition enter-active-class="duration-500 ease-in" enter-from-class="transform opacity-0"
            enter-to-class="opacity-100" leave-active-class="duration-500 ease-in" leave-from-class="opacity-100"
            leave-to-class="transform opacity-0"><keep-alive>
                <Player ref="player" :key="1" />
            </keep-alive></Transition>
    </div>
</template>
<script setup>
import Player from "@/Layouts/Player.vue";
import Navigation from "@/Layouts/Navigation.vue";
import TopBar from "@/Layouts/TopBar.vue";
import Footer from "@/Layouts/Footer.vue";
import Notification from "@/components/Notification.vue";

import { ref } from 'vue'
const player = ref()
const nav = ref()

function openMenu() {
    nav.value?.toggleMenu();
}
</script>
